import { render, staticRenderFns } from "./file-size.vue?vue&type=template&id=1aa6276e&"
import script from "./file-size.vue?vue&type=script&lang=ts&"
export * from "./file-size.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports